import * as React from 'react'
import Contact from '@/components/contact'
import Detail from './detail'
import { Sidebar, AppBarHeader, TabsNavigation } from '@components'
import { Container } from './styled'
import { tabs } from './tabStorefront'
import { Grid, Container as Wrapper } from '@mui/material'
import ClipLoader from 'react-spinners/ClipLoader'
import {
  useGetCompany,
  useGetCompanyByDomain,
} from '@/services/suppliers/suppliers.service'
import { useGetCompanyProfile } from '@/services/storefront/storefront.service'
import { IStorefrontProps } from './types'
import { useParams } from 'react-router'
import { LoaderWrapper } from '../product/styled'
import { useAppSelector } from '@/app/hooks'
import MainLayout from '@/components/layout'
import { EmptyStateWrapper, Info } from '../dashboard/posting/styled'
import { ResultsTitle } from '@/components/grid-cards/styled'

const Storefront: React.FC<IStorefrontProps> = (props) => {
  const supportEmail = process.env.SUPPORT_EMAIL
  const userRole = useAppSelector((state) => state.authUser.userRole)
  const userId = useAppSelector((state) => state.authUser.userId)
  const { profileId } = useParams()

  const {
    data: companyProfileData,
    isLoading: isCompanyProfileLoading,
    error: companyProfileError,
  } = useGetCompanyProfile(profileId!, !!profileId)

  const { data: companyData, isLoading: isCompanyLoading } =
    useGetCompanyByDomain(
      companyProfileData?.data?.domain!,
      !!companyProfileData?.data?.domain,
    )

  const capitalize = (word: string) => {
    if (!word) return ''
    return word[0].toUpperCase() + word.slice(1).toLowerCase()
  }

  const showRightPanel = userId && userRole === 'buyer'

  if (isCompanyProfileLoading) {
    return (
      <MainLayout>
        <LoaderWrapper>
          <ClipLoader
            color="#000000"
            loading={isCompanyProfileLoading}
            size={30}
          />
        </LoaderWrapper>
      </MainLayout>
    )
  }

  return (
    <MainLayout>
      <>
        {companyProfileError && (
          <EmptyStateWrapper>
            <ResultsTitle>Haven't found what you're looking for?</ResultsTitle>
            <Info>
              {' '}
              <a href={`mailto:${supportEmail}`}>
                Contact Kamba's Sourcing Team
              </a>{' '}
              <span>for Help</span>
            </Info>
          </EmptyStateWrapper>
        )}
        {!companyProfileError && (
          <Grid
            container
            direction="row"
            alignItems="flex-start"
            overflow="auto"
            justifyContent={showRightPanel ? 'flex-start' : 'center'}
            sx={{
              paddingX: 5,
              paddingTop: 3,
            }}
            id="scroll-container"
          >
            {/* Left Side */}
            <Grid item xs={12} md={7}>
              <Detail
                company={companyProfileData?.data || null}
                companyNative={companyData?.data}
              />
            </Grid>
            {/* Right Side */}
            {showRightPanel && companyProfileData?.data && (
              <Grid
                item
                xs={12}
                md={4}
                xl={3}
                sx={{
                  ml: { md: 3, xs: 0 },
                  mt: { xs: 2, md: 0 },
                  position: 'sticky',
                  top: '0',
                  overflow: 'hidden',
                }}
                id="rightBox"
              >
                <Contact
                  companyName={capitalize(companyProfileData?.data?.name!)}
                  phoneNumber={companyProfileData?.data?.phoneNumber}
                  showIconsInfo={true}
                  companyId={companyData?.data.id}
                  origin="storefront"
                />
              </Grid>
            )}
          </Grid>
        )}
      </>
    </MainLayout>
  )
}

export default Storefront
